interface XSellErrorArgs {
  message: string
  data: Record<string, string | number | unknown>
}

export class WebApiError extends Error {
  constructor(args: XSellErrorArgs) {
    const { message, data } = args
    super(message)
    this.name = WebApiError.name
    Object.entries(data).forEach(([key, value]) => {
      // @ts-ignore
      this[key] = value
    })
  }
}
